import { EventEmitter } from '@angular/core';

export class TranslatorService {
  public currentLanguage: EventEmitter<string> = new EventEmitter<string>();

  changeLanguage(language: string): void {
    this.currentLanguage.emit(language);
  }
}
